






































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { RefuelingEvent } from "@/types/refuelingEvent";
import * as firebase from "firebase/app";
import "firebase/database";

@Component
export default class RefuelingForm extends Vue {
  name = "RefuelingForm";
  show = false;
  date = new Date();
  mileage: number | null = null;
  liters: number | null = null;
  pricePerLiter: number | null = null;
  isValid = true;
  lat = 0
  lon = 0

  rules = {
    number: (value: string) => !!+value || "Keine gültige Zahl",
  };

  created() {
    navigator.geolocation.getCurrentPosition(position => {
      this.lat = position.coords.latitude;
      this.lon = position.coords.longitude;
    });
  }

  submitForm() {
    const entry = this.createRefuelingEvent();
    firebase.database().ref("refueling-events").push(entry).then(() => {
        (this.$refs["form"] as any).reset();
        this.show = false;
    });
  }

  private onClosingDialog() {
    (this.$refs["form"] as any).reset();
  }

  private createRefuelingEvent(): RefuelingEvent {
    return {
      pricePerLiter: this.pricePerLiter ?? 0,
      mileage: this.mileage ?? 0,
      liters: this.liters ?? 0,
      date: new Date().toISOString(),
      user: firebase.auth().currentUser?.email ?? "",
      location: {
        latitude: this.lat,
        longitude: this.lon
      }
    };
  }
}
